import { ApiResponse } from "data/interfaces/api";
import { SignInDataPost, SignInDataResponse } from "data/interfaces/signIn";
import { api } from "services/axios/api";
import { getErrorsByApi } from "utils/getErrorsByApi";

export async function postSignIn(dataPost: SignInDataPost) {
	try {
		const result: ApiResponse<SignInDataResponse> = await api
			.post("/autenticacao/autenticar", dataPost)
			.then((response) => response.data);

		return Object.prototype.hasOwnProperty.call(result.data, "token")
			? result.data
			: null;
	} catch (error: any) {
		getErrorsByApi(error, "Tivemos problemas internos ao realizar o login");
	}
	return null;
}
